import API from '@/API/request';

export const annualApplicationApi = {
  // 新增年度规划
  annualPlanCreate: (params) => API.post('/annualPlan/create', params),
  // 编辑年度规划
  annualPlanEdit: (params) => API.post('/annualPlan/edit', params),
  // 改变年度规划
  annualPlanChange: (params) => API.post('/annualPlan/change', params),
  // 年度规划导出（返回二进制流）
  annualPlanExport: (params) => API.get('/annualPlan/export' + `?year=${params.year || ''}&type=${params.type || ''}&departmentId=${params.departmentId || ''}&submitUser=${params.submitUser || ''}&status=${params.status || ''}`, { responseType: 'arraybuffer', headers: { download: true } }),
  // 年度规划列表
  annualPlanList: (params) => API.post('/annualPlan/list', params),
  // 年度规划查看审批记录
  annualPlanApprovalRecords: (params) => API.get(`/annualPlan/all_process_history/${params.id}`),
  // 年度规划详情
  annualPlanDetail: (params) => API.post('/annualPlan/detail', params),
  // 年度规划审批召回
  annualPlanRecall: (params) => API.post('/annualPlan/recall', params),
  // 年度规划审批废弃
  annualPlanAbandon: (params) => API.post('/annualPlan/abandon', params),
  // 年度规划审批通过
  annualPlanApprove: (params) => API.post('/annualPlan/approve', params),
  // 年度规划审批驳回
  annualPlanReject: (params) => API.post('/annualPlan/reject', params),
  // 获取当前年份
  currentYear: () => API.get('/annualPlan/current_year'),
  // 获取列表已有年度
  getYears: () => API.get('/annualPlan/years'),
  // 提交季度填报
  quarterSubmit: (params) => API.post('/annualPlan/quarter/submit', params),
  // 编辑季度填报
  quarterEdit: (params) => API.post('/annualPlan/quarter/edit', params),
  // 季度填报详情
  quarterDetail: (params) => API.post('/annualPlan/quarter/detail', params),
  // 季度填报召回
  quarterRecall: (params) => API.post(`/annualPlan/quarter/recall`, params),
  // 季度填报审批通过
  quarterApprove: (params) => API.post('/annualPlan/quarter/approve', params),
  // 季度填报审批驳回
  quarterReject: (params) => API.post('/annualPlan/quarter/reject', params)
};
